// al final de tot hi ha un export
function llista_municipis() {
var municipis = [
{'lon': 2.1681, 'lat': 41.3838,'nom': 'Barcelona','hab':1664182},
{'lon': 2.1093, 'lat': 41.3585,'nom': 'L\'Hospitalet de Llobregat','hab':269382},
{'lon': 2.01120, 'lat': 41.56244,'nom': 'Terrassa','hab':223627},
{'lon': 2.2463, 'lat': 41.4505,'nom': 'Badalona','hab':223166},
{'lon': 2.10800, 'lat': 41.54721,'nom': 'Sabadell','hab':216520},
{'lon': 0.62276, 'lat': 41.61300,'nom': 'Lleida','hab':140403},
{'lon': 1.2480, 'lat': 41.1631,'nom': 'Tarragona','hab':136496},
{'lon': 2.44576, 'lat': 41.53980,'nom': 'Mataró','hab':129661},
{'lon': 2.20784, 'lat': 41.44717,'nom': 'Santa Coloma de Gramenet','hab':120443},
{'lon': 1.10821, 'lat': 41.15515,'nom': 'Reus','hab':106168},
{'lon': 2.81230, 'lat': 41.97556,'nom': 'Girona','hab':103369},
{'lon': 2.08147, 'lat': 41.47224,'nom': 'Sant Cugat del Vallès','hab':92977},
{'lon': 2.07026, 'lat': 41.35607,'nom': 'Cornellà de Llobregat','hab':89936},
{'lon': 2.03973, 'lat': 41.34603,'nom': 'Sant Boi de Llobregat','hab':84500},
{'lon': 2.03051, 'lat': 41.49243,'nom': 'Rubí','hab':78591},
{'lon': 1.82719, 'lat': 41.72954,'nom': 'Manresa','hab':78245},
{'lon': 1.72720, 'lat': 41.21878,'nom': 'Vilanova i la Geltrú','hab':67733},
{'lon': 1.97652, 'lat': 41.28349,'nom': 'Castelldefels','hab':67460},
{'lon': 2.0172, 'lat': 41.3177,'nom': 'Viladecans','hab':67197},
{'lon': 2.09405, 'lat': 41.32509,'nom': 'El Prat de Llobregat','hab':65385},
{'lon': 2.28591, 'lat': 41.60771,'nom': 'Granollers','hab':62419},
{'lon': 2.1384, 'lat': 41.4920,'nom': 'Cerdanyola del Vallès','hab':57855},
{'lon': 2.21584, 'lat': 41.53925,'nom': 'Mollet del Vallès','hab':51600},
{'lon': 2.25433, 'lat': 41.93034,'nom': 'Vic','hab':47630},
{'lon': 2.95859, 'lat': 42.26635,'nom': 'Figueres','hab':47235},
{'lon': 2.08896, 'lat': 41.37736,'nom': 'Esplugues de Llobregat','hab':47150},
{'lon': 2.00185, 'lat': 41.30403,'nom': 'Gavà','hab':47057},
{'lon': 2.04680, 'lat': 41.38095,'nom': 'Sant Feliu de Llobregat','hab':45467},
{'lon': 1.6211, 'lat': 41.5791,'nom': 'Igualada','hab':40742},
{'lon': 1.6960, 'lat': 41.3443,'nom': 'Vilafranca del Penedès','hab':40154},
{'lon': 2.7901, 'lat': 41.6782,'nom': 'Blanes','hab':39914},
{'lon': 2.15488, 'lat': 41.49933,'nom': 'Ripollet','hab':39179},
{'lon': 2.84193, 'lat': 41.69866,'nom': 'Lloret de Mar','hab':39089},
{'lon': 1.5316, 'lat': 41.2200,'nom': 'Vendrell, el','hab':38373},
{'lon': 2.21903, 'lat': 41.43124,'nom': 'Sant Adrià de Besòs','hab':37447},
{'lon': 2.18760, 'lat': 41.48371,'nom': 'Montcada i Reixac','hab':36803},
{'lon': 2.4913, 'lat': 42.1833,'nom': 'Olot','hab':35926},
{'lon': 1.0617, 'lat': 41.0664,'nom': 'Cambrils','hab':34734},
{'lon': 2.05736, 'lat': 41.36750,'nom': 'Sant Joan Despí','hab':34267},
{'lon': 0.52202, 'lat': 40.81346,'nom': 'Tortosa','hab':33439},
{'lon': 2.12436, 'lat': 41.51684,'nom': 'Barberà del Vallès','hab':33334},
{'lon': 2.7901, 'lat': 41.9731,'nom': 'Salt','hab':32138},
{'lon': 1.7657, 'lat': 41.2559,'nom': 'Sant Pere de Ribes','hab':31111},
{'lon': 1.81770, 'lat': 41.23632,'nom': 'Sitges','hab':29553},
{'lon': 1.92422, 'lat': 41.47612,'nom': 'Martorell','hab':28772},
{'lon': 2.3568, 'lat': 41.4940,'nom': 'Premià de Mar','hab':28531},
{'lon': 1.1366, 'lat': 41.0775,'nom': 'Salou','hab':28526},
{'lon': 2.01027, 'lat': 41.39343,'nom': 'Sant Vicenç dels Horts','hab':28268},
{'lon': 2.6891, 'lat': 41.6269,'nom': 'Pineda de Mar','hab':27984},
{'lon': 1.56855, 'lat': 41.20056,'nom': 'Calafell','hab':27601},
{'lon': 1.9710, 'lat': 41.4511,'nom': 'Sant Andreu de la Barca','hab':27569},
{'lon': 2.18137, 'lat': 41.53278,'nom': 'Santa Perpètua de Mogoda','hab':25999},
{'lon': 2.01738, 'lat': 41.41321,'nom': 'Molins de Rei','hab':25940},
{'lon': 2.0864, 'lat': 41.6144,'nom': 'Castellar del Vallès','hab':24488},
{'lon': 1.25129, 'lat': 41.28622,'nom': 'Valls','hab':24477},
{'lon': 1.8900, 'lat': 41.5442,'nom': 'Olesa de Montserrat','hab':24144},
{'lon': 2.3109, 'lat': 41.4800,'nom': 'El Masnou','hab':23831},
{'lon': 3.1616, 'lat': 41.9214,'nom': 'Palafrugell','hab':23244},
{'lon': 1.1556, 'lat': 41.1097,'nom': 'Vila-seca','hab':22555},
{'lon': 1.8681, 'lat': 41.5380,'nom': 'Esparreguera','hab':22302},
{'lon': 3.0304, 'lat': 41.7844,'nom': 'Sant Feliu de Guíxols','hab':22097},
{'lon': 0.5795, 'lat': 40.7086,'nom': 'Amposta','hab':21115},
{'lon': 2.3859, 'lat': 41.5043,'nom': 'Vilassar de Mar','hab':21035},
{'lon': 2.2768, 'lat': 41.9992,'nom': 'Manlleu','hab':20912},
{'lon': 2.29229, 'lat': 41.61665,'nom': 'Franqueses del Vallès, les','hab':20364},
{'lon': 2.08293, 'lat': 41.53180,'nom': 'Sant Quirze del Vallès','hab':20195},
{'lon': 2.7625, 'lat': 42.1120,'nom': 'Banyoles','hab':20053}
];
return municipis;
}

export default llista_municipis;
